import { h, defineComponent } from 'vue';

interface LogoProps {
  customClass?: string;
}

export const Logo = defineComponent<LogoProps>({
  name: 'Logo',
  props: ['customClass'],
  setup(props) {
    return function render() {
      return h('img', {
        attrs: {
          class: `logo-img ${props.customClass ?? ''}`,
          src: '/lumiform.svg',
        },
      });
    };
  },
});

export function logo(props?: LogoProps) {
  return h(Logo, { props });
}
